import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { UtilService } from './util-service';

/*
  Generated class for the CadastroPerguntasService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class CadastroPerguntasService {

  constructor(http: HttpClient,
    private utilService: UtilService) {
  }

  /* =================================================================================
  *
  *   Requisições com o servidor
  *
  * ================================================================================== */

  //Obtem lista de PCAs
  public obterListaPerguntas(): Observable<any> {
    let urlObtencaoDados: string = "categoria/listarCadastro";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarCategoria(categoriaJson): Observable<any> {
    let urlObtencaoDados: string = "categoria/salvar";
    return this.utilService.postJSON(urlObtencaoDados, categoriaJson);
  }

  public salvarPergunta(categoriaId, perguntaJson): Observable<any> {
    let urlObtencaoDados: string = "questao/salvarPergunta/" + categoriaId;
    return this.utilService.postJSON(urlObtencaoDados, perguntaJson);
  }

  public excluirPergunta(idPergunta): Observable<any> {
    let urlObtencaoDados: string = "questao/deletar/" + idPergunta;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public obterListaCategorias() {
    let urlObterQuestoes = "questao/listarCategorias";
    return this.utilService.getJSON(urlObterQuestoes);
  }


}



// WEBPACK FOOTER //
// ./src/providers/cadastro-perguntas-service.ts